__turbopack_context__.v({
  "backButton": "PhoneMockup-module__knzvna__backButton",
  "backCount": "PhoneMockup-module__knzvna__backCount",
  "chatBubbleAgent": "PhoneMockup-module__knzvna__chatBubbleAgent",
  "chatBubbleUser": "PhoneMockup-module__knzvna__chatBubbleUser",
  "chatContent": "PhoneMockup-module__knzvna__chatContent",
  "contactName": "PhoneMockup-module__knzvna__contactName",
  "dynamicIsland": "PhoneMockup-module__knzvna__dynamicIsland",
  "facetimeButton": "PhoneMockup-module__knzvna__facetimeButton",
  "fadeIn": "PhoneMockup-module__knzvna__fadeIn",
  "fadeOut": "PhoneMockup-module__knzvna__fadeOut",
  "imessageLabel": "PhoneMockup-module__knzvna__imessageLabel",
  "inputBar": "PhoneMockup-module__knzvna__inputBar",
  "inputField": "PhoneMockup-module__knzvna__inputField",
  "inputPlaceholder": "PhoneMockup-module__knzvna__inputPlaceholder",
  "iphoneFrame": "PhoneMockup-module__knzvna__iphoneFrame",
  "messageAnimateIn": "PhoneMockup-module__knzvna__messageAnimateIn",
  "messageAnimateOut": "PhoneMockup-module__knzvna__messageAnimateOut",
  "messageDelay1": "PhoneMockup-module__knzvna__messageDelay1",
  "messageDelay2": "PhoneMockup-module__knzvna__messageDelay2",
  "messageDelay3": "PhoneMockup-module__knzvna__messageDelay3",
  "messageSlideIn": "PhoneMockup-module__knzvna__messageSlideIn",
  "messageTimestamp": "PhoneMockup-module__knzvna__messageTimestamp",
  "messagesHeader": "PhoneMockup-module__knzvna__messagesHeader",
  "plusButton": "PhoneMockup-module__knzvna__plusButton",
  "statusBar": "PhoneMockup-module__knzvna__statusBar",
  "statusTime": "PhoneMockup-module__knzvna__statusTime",
  "text": "PhoneMockup-module__knzvna__text",
  "timestampText": "PhoneMockup-module__knzvna__timestampText",
  "userBubbleText": "PhoneMockup-module__knzvna__userBubbleText",
});
